<mat-card appearance="outlined" class="ai-card">
  <mat-card-header>
    <mat-card-title class="mat-font-title-sm">Features</mat-card-title>
  </mat-card-header>

  @if (loading()) {
    <mat-progress-bar mode="indeterminate" />
  }

  <mat-card-content class="p-0">
  <table mat-table [dataSource]="features()" class="w-100">

    <!-- Index column -->
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let row; let i = index">{{ resolveFeatureId(row, i) }}</td>
    </ng-container>

    <!-- Geometry type column -->
    <ng-container matColumnDef="geometry_type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let row">{{ row.geometry?.type ?? '—' }}</td>
    </ng-container>

    <!-- Properties column -->
    <ng-container matColumnDef="properties">
      <th mat-header-cell *matHeaderCellDef>Fields</th>
      <td mat-cell *matCellDef="let row">
        <button mat-button (click)="openFeatureDetail(row)">
          {{ row.properties ? objectKeys(row.properties).length : 0 }} fields
        </button>
      </td>
    </ng-container>

    <!-- Actions column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button matIconButton [matMenuTriggerFor]="rowMenu" aria-label="Row actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #rowMenu>
          <button mat-menu-item (click)="onZoomToFeature(row)">
            <mat-icon>zoom_in</mat-icon>
            <span>Zoom to feature</span>
          </button>
          <button mat-menu-item (click)="onCopyJson(row)">
            <mat-icon>content_copy</mat-icon>
            <span>Copy JSON</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  </mat-card-content>

  <mat-paginator
    [length]="totalFeatures() ?? 0"
    [pageSize]="layer().pageSize ?? 100"
    [pageSizeOptions]="[25, 50, 100]"
    (page)="onPageChange($event)" />
</mat-card>
